import { render, staticRenderFns } from "./ugmidland.vue?vue&type=template&id=5e94b11f&"
import script from "./ugmidland.vue?vue&type=script&lang=js&"
export * from "./ugmidland.vue?vue&type=script&lang=js&"
import style0 from "./ugmidland.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports